var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('label',[_vm._v("HHAs per program")]),_vm._v(" "),_c('GChart',{ref:"chart",attrs:{"type":"ColumnChart","data":_vm.chartData,"options":_vm.chartOptions,"events":_vm.chartEvents},on:{"ready":_vm.onChartReady}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f4e1c9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/LHCSADashboardChart1Component.vue
// module id = null
// module chunks = 